import React from "react";
import PropTypes from "prop-types";

const ForwardIcon = ({ width, height, viewBox }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
  >
    <path
      stroke="none"
      fillRule="nonzero"
      d="M7.586 9L.293 16.293a1 1 0 0 0 1.414 1.414l8-8a1 1 0 0 0 0-1.414l-8-8A1 1 0 1 0 .293 1.707L7.586 9z"
    />
  </svg>
);

ForwardIcon.defaultProps = {
  width: 10,
  height: 23,
  viewBox: "0 0 10 18"
};

ForwardIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  viewBox: PropTypes.string
};

export default ForwardIcon;
